module.exports = __webpack_public_path__ + "img/1514344872.bf987ce8.jpg";